// Dynamic backend URL - works for preview, production, and any custom domain.
// In browser we ALWAYS use the same origin, because Emergent ingress routes
// /api/* to the backend regardless of the host (preview.emergentagent.com OR limhappy.com).
// This prevents CRA from baking a preview URL into the production bundle.
const getBackendUrl = () => {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const BACKEND_URL = getBackendUrl();
export const API = `${BACKEND_URL}/api`;
